import Backbone from '@polleverywhere/backbone'
import Base from './base'
import ActivityCollection from './activity_collection'
import $ from 'jquery'
import URI from 'urijs'

function normalizeAttrs (attrs) {
  if (attrs.id === -1) {
    attrs.name = Group.defaultName
  }
  return attrs
}

export default class Group extends Base {
  /**
   * Returns the name for ungrouped groups that have an id === -1.
   * @return {string}
   */
  static get defaultName () { return 'Default' }

  static get defaultId () { return -1 }

  get urlRoot () { return '/api/groups' }

  get defaults () {
    return {
      id: null,
      name: 'New Group',
      collapsed: false,
      loaded: false,
      current: false
    }
  }

  /**
   * Read-only property to hold activity collection inside this group.
   * @return {ActivityCollection}
   */
  get activities () {
    if (!this._activities) {
      this._activities = new ActivityCollection(null, {
        group_id: this.id
      })
    }

    // Keep activities count attribute in sync with internal collection.
    this.listenTo(this._activities, 'update', (activities) => {
      this.set('activities_count', activities.length)
    })

    return this._activities
  }

  preinitialize (attrs = {}) {
    // Run it through our normalizer to perform any translations if necessary.
    attrs = normalizeAttrs(attrs)
  }

  initialize () {
    super.initialize(...arguments)

    this.on('change:id', (_, id) => {
      this.activities.group_id = id
    })
  }

  /**
   * Convert this into the specified target type.
   * @param {string} targetType What to convert this into, e.g. `group`
   * @return {Promise}
   */
  convertTo (targetType) {
    const key = this.get('id') || this.get('permalink')
    const url = URI(this.urlRoot)
      .segment(key.toString())
      .segment(`convert_to_${targetType}`)
      .toString()
    return Backbone.ajax({
      url,
      method: 'post',
      dataType: 'json'
    })
  }

  markAsLoaded () {
    this.set({ loaded: true })
  }

  toggleCollapse () {
    const toggle = !this.get('collapsed')

    if (this.isRealGroup()) {
      const opts = { patch: true, wait: true }
      return this.save({ collapsed: toggle }, opts)
    } else {
      this.set({ collapsed: toggle })
      return $.Deferred().resolve()
    }
  }

  url (opts = {}) {
    return URI(super.url(...arguments)).setQuery(opts).toString()
  }

  validate (attrs = {}) {
    if (attrs.name && !attrs.name.length) {
      return 'Group name cannot be empty.'
    }
  }

  isRealGroup () {
    return this.id !== Group.defaultId
  }

  parse (attrs) {
    // Run it through our normalizer to perform any translations if necessary.
    attrs = normalizeAttrs(attrs)

    if (attrs.activities) {
      if (this.activities) {
        this.activities.set(attrs.activities)
      } else {
        this.activities = new ActivityCollection(attrs.activities, { group_id: this.id, user_id: this.get('owner_id') })
      }
    }

    return super.parse(...arguments)
  }
}
